/* Terms of Service page — assets/monmouth-terms-of-service.js (same behaviour as monmouth-privacy-policy.js, with #t-1 … #t-22)
   One section open at a time, driven by the contents pane (links) and #t-1 … #t-22 in the address bar.
   Vanilla JS. Without it every section is simply shown one after another (see the CSS). */
(function () {
  'use strict';
  var page = document.getElementById('mc-pp-page');
  if (!page || page.getAttribute('data-pp-init')) return;
  page.setAttribute('data-pp-init', '1');

  var nav = document.querySelector('.mc-nav');
  var paneEl = document.getElementById('mc-pp-nav');
  var secs = [].slice.call(page.querySelectorAll('.mc-pp-sec'));
  var links = [].slice.call(page.querySelectorAll('[data-pp-link]'));
  var paneLinks = [].slice.call(paneEl ? paneEl.querySelectorAll('.mc-legal-toc__link') : []);
  var list = paneEl ? paneEl.querySelector('.mc-legal-toc__list') : null;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var current = 0;

  /* Height the site header really covers at the top of the viewport (0 if it scrolls away). */
  function navHeight() {
    if (!nav) return 0;
    var pos = window.getComputedStyle(nav).position;
    if (pos === 'fixed') return nav.offsetHeight;
    if (pos === 'sticky' && nav.parentElement && nav.parentElement.offsetHeight > nav.offsetHeight + 2) return nav.offsetHeight;
    return 0;
  }
  function setVars() {
    var h = navHeight();
    page.style.setProperty('--mc-pp-top', (h + 16) + 'px');
    page.style.setProperty('--mc-legal-offset', (h + 16) + 'px');
  }

  function indexFromHash() {
    var m = /^#t-(\d+)$/.exec(location.hash || '');
    var n = m ? parseInt(m[1], 10) : 1;
    return (n >= 1 && n <= secs.length) ? n - 1 : 0;
  }

  function centerChip(a) {
    if (!list || !a || list.scrollWidth <= list.clientWidth) return;
    var left = a.parentNode.offsetLeft - (list.clientWidth - a.parentNode.offsetWidth) / 2;
    if (list.scrollTo) list.scrollTo({ left: left, behavior: reduce.matches ? 'auto' : 'smooth' }); else list.scrollLeft = left;
  }

  /* Desktop: the pane is a scrollable card (22 items); keep the current item inside its visible part */
  function keepInPane(a) {
    if (!paneEl || !a || paneEl.scrollHeight <= paneEl.clientHeight) return;
    var pr = paneEl.getBoundingClientRect(), ar = a.getBoundingClientRect();
    if (ar.top < pr.top + 40) paneEl.scrollTop -= (pr.top + 40 - ar.top);
    else if (ar.bottom > pr.bottom - 12) paneEl.scrollTop += (ar.bottom - pr.bottom + 12);
  }

  function show(i, opts) {
    opts = opts || {};
    if (!secs[i]) return;
    current = i;
    secs.forEach(function (s, k) { s.classList.toggle('is-current', k === i); });
    paneLinks.forEach(function (a, k) {
      a.classList.toggle('is-active', k === i);
      if (k === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    centerChip(paneLinks[i]);
    keepInPane(paneLinks[i]);
    if (opts.scroll) {
      setVars();
      /* Phone/tablet: keep the contents chips in view above the opened section; desktop: start at the section */
      var anchor = (window.innerWidth < 900 && paneEl) ? paneEl : secs[i];
      var top = anchor.getBoundingClientRect().top + window.pageYOffset - navHeight() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }
    if (opts.focus) {
      var h = secs[i].querySelector('.mc-pp-sec__h');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
  }

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      var n = parseInt(a.getAttribute('data-pp-link'), 10);
      if (isNaN(n) || !secs[n - 1]) return;
      e.preventDefault();
      show(n - 1, { scroll: true, focus: true });
      var hash = '#t-' + n;
      if (location.hash !== hash && window.history && history.pushState) history.pushState(null, '', hash);
    });
  });

  /* Back / forward / hand-edited address */
  function fromHash() { show(indexFromHash(), { scroll: true }); }
  window.addEventListener('popstate', fromHash);
  window.addEventListener('hashchange', fromHash);

  /* First paint: the inline script in the section already marked the right section; line everything else up */
  setVars();
  window.addEventListener('resize', setVars);
  show(indexFromHash(), { scroll: false });
  if (/^#t-\d+$/.test(location.hash || '')) {
    window.addEventListener('load', function () { show(indexFromHash(), { scroll: true }); });
  }
})();
